import { processTickForRecurringGameDataObjects } from "../objects/process_tick_for_recurring_gamedata_objects";  
import activatePendingJob from "../objects/activate_pending_job";
import checkPendingJobLoans from "./check_pending_job_loans";
import { createTaxAmtExpense } from "../../../objects/AssetsExpenses/create_tax_amt_expense";
import { setNbrMonthsNegative } from "../objects/set_nbr_months_negative";
import { calcMonthlyIncome } from "../../../objects/CommonUse/calcMonthlyIncome";
import processUnlockedFeatures from "./process_unlocked_features";
import processConditionsEndOfTurn from "./process_conditions_end_of_turn";
import updateEventArr from "../objects/update_event_arr";
import determineCreditScore from "./determine_credit_score";
import checkForAchievements from "../../../objects/CommonUse/check_for_achievements";
import createUnlockedFeatureRoadmapArr from "./create_unlocked_feature_roadmap_arr";


export const processNextTurn = (gameData, pictureInfo, eventConditions, savingsInfo, creditCardInfo, 
        timeWizardInfo, totalNbrGameMonths, summaryInvestment, investmentMaster, eventTracker,
        moneyMgmtTestArr, funStuffInfo) => {
        let eventTrackerArr = [];
        let notificationArr = [];
        let eventTrackerObj = {};
        // Delete assetTable entries if nbrMonths is 0
        gameData.assetTable =
            processTickForRecurringGameDataObjects("asset", gameData.assetTable);

        // Delete expenseTable entries if nbrMonths is 0
        gameData.expenseTable =
            processTickForRecurringGameDataObjects("expense", gameData.expenseTable);

        // Delete loanTableEntries if nbrMonths is 0
        gameData.loanTable =
            processTickForRecurringGameDataObjects("loan", gameData.loanTable);
        let monthsPerTurn = 1;
        if (timeWizardInfo.monthsPerTurn){
             monthsPerTurn = timeWizardInfo.monthsPerTurn;
        }
        // Check to see if any jobs are in the pending job table that should be activated
        let pictureInfoChanged = false;
        if (gameData.pendingJob &&
            Object.keys(gameData.pendingJob).length !== 0) {
            let pendingJob = gameData.pendingJob;
            if (pendingJob.jobStartDate <= gameData.currentGameDate) {
                const pendingJobObj = activatePendingJob(gameData, pictureInfo, eventTracker);
                    gameData.pendingJob = {};
         
                notificationArr.push(pendingJobObj.notificationObj);
                eventTrackerObj = pendingJobObj.eventTrackerObj;
                pictureInfo = pendingJobObj.pictureInfo;
                pictureInfoChanged = true;
                if (eventTracker === true){
                    eventTrackerArr.push(eventTrackerObj)
                }
            } else {
                checkPendingJobLoans(gameData, pictureInfo);
            }
        }
              
        //  the following should be done after month is incremented!
        //  subtract/remove conditions based on time, add new monthly conditions
        gameData.conditionsTable = 
            processConditionsEndOfTurn(eventConditions, gameData, monthsPerTurn);
        // remove current payroll tax and add new payroll tax expense
        const taxExpenseObj = createTaxAmtExpense(gameData.expenseTable, 
            gameData.assetTable, gameData.currentGameDate);
        let newTaxAmt = 0;
        let taxChgExpenseTable = {};
        if (taxExpenseObj.taxAmtChgd === true){
            if (eventTracker === true){
                newTaxAmt = taxExpenseObj.newTaxAmt;
                taxChgExpenseTable = JSON.parse(JSON.stringify(gameData.expenseTable));     
                eventTrackerObj = updateEventArr("taxItem", taxChgExpenseTable, {}, {}, {}, newTaxAmt);
                eventTrackerArr.push(eventTrackerObj);
            }
            gameData.expenseTable = taxExpenseObj.expenseTable;
        }
       // Process tick for ageNbr for the car
        gameData.carInfo.carAge = +gameData.carInfo.carAge + +monthsPerTurn;

        // Process tick for end condition on three months in a row with negative balance
        let monthsNegativeObj = setNbrMonthsNegative(gameData.currentCash,
            gameData.nbrMonthsNegative,
            gameData.currentMoodPoints, 
            gameData.nbrMonthsMoodNegative);
        gameData.nbrMonthsNegative = monthsNegativeObj.nbrMonthsCashNegative;
        gameData.nbrMonthsMoodNegative = monthsNegativeObj.nbrMonthsMoodNegative;
        let cashAmt = JSON.parse(JSON.stringify(+gameData.currentCash));
        const incomeObj = calcMonthlyIncome(gameData.assetTable, 
            gameData.expenseTable, gameData.loanTable);
        const monthlyIncome = incomeObj.income;
       
        // calculating credit score before applying this month's credit charges because
        // the credit score should be based on end of previous turn status
        // if balance paid prior to end of turn, prevPeriodOutstandBalance is $0 which is correct
        const creditReport = determineCreditScore(creditCardInfo, 
            gameData.loanTable,
            gameData.currentGameDate,
            gameData.gameNbrMonths,
            timeWizardInfo);
        // check for achievements earned before credit card updates for current period.
        // update the achievementArr in the games-collection
        let newAchievementArr = [];
        const nbrMonthsPlayed = +totalNbrGameMonths - +gameData.gameNbrMonths;
        const creditScore = creditReport.creditScore;
        newAchievementArr = checkForAchievements(gameData, savingsInfo,
            creditCardInfo, summaryInvestment, investmentMaster, nbrMonthsPlayed,
            creditScore, monthsPerTurn, moneyMgmtTestArr, timeWizardInfo, "endOfTurn");
             
        const unlockedFeaturesUpdtObj = 
            processUnlockedFeatures(gameData, creditCardInfo, monthlyIncome,
                totalNbrGameMonths, monthsPerTurn, cashAmt, creditReport
        );
        let updateCreditCard = false;
       
        if (unlockedFeaturesUpdtObj.updateCreditCard === true){
            creditCardInfo = unlockedFeaturesUpdtObj.creditCardInfo;
            updateCreditCard = true;
        }
        if (unlockedFeaturesUpdtObj.updateConditionsTable === true){
            gameData.conditionsTable = unlockedFeaturesUpdtObj.conditionsTable;
        }
        //const creditCardAmount = unlockedFeaturesUpdtObj.creditCardAmount;
        gameData.unlockedFeatures = unlockedFeaturesUpdtObj.unlockedFeatures;
        gameData.iconTable = unlockedFeaturesUpdtObj.iconTable;

        let unlockedFeaturesRoadmapArr = [];
        if (gameData.unlockedFeatures.length > 0){
            unlockedFeaturesRoadmapArr = 
                createUnlockedFeatureRoadmapArr(gameData.unlockedFeatures, nbrMonthsPlayed, 
                    gameData.currentCash, savingsInfo, monthlyIncome, creditReport, gameData.assetTable, 
                    gameData.currentGameDate, summaryInvestment, funStuffInfo, creditCardInfo,
                    timeWizardInfo, true);
        }
           
        const returnObj = {endGameReason: monthsNegativeObj.endGameReason,
            updateCreditCard: updateCreditCard, currentCash: unlockedFeaturesUpdtObj.currentCash, 
            unlockedFeaturesObj: unlockedFeaturesUpdtObj, 
            newAchievementArr: newAchievementArr,
            notificationArr: notificationArr,
            pictureInfoChanged: pictureInfoChanged,
            pictureInfo: pictureInfo,
            eventTrackerArr: eventTrackerArr,
            unlockedFeaturesRoadmapArr: unlockedFeaturesRoadmapArr
        }
        return returnObj;
}
export default processNextTurn;